<div class="overlay" [ngClass]="{'overlay': overlay}" *ngIf="show">
  <mat-progress-spinner
    [color]=color
    [mode]=mode
    aria-label=""
    *ngIf="show"
  ></mat-progress-spinner>
</div>
